import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
// Model
import { Auth } from 'src/app/models/auth';
import { CedenteContrato } from 'src/app/models/cedente-contrato';
import { PedidoCadastro } from 'src/app/models/pedido-cadastro';
import { Purchase, PurchaseItens, Order, OrderItens} from 'src/app/models/purchase';
// Service
import { AuthenticationService } from 'src/app/services/authentication.service';

import { ContratoService } from 'src/app/services/contrato.service';
import { PedidoDataService } from 'src/app/services/pedido-data.service';
import { GestorService } from 'src/app/services/gestor.service';
// Enum
import { ApiError } from 'src/app//shared/enums/api-error.enum';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { CategoriaProduto } from 'src/app/shared/enums/categoria-produto.enum';

// Validação
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PedidoService } from 'src/app/services/pedido.service';
import { Pedido } from 'src/app/models/pedido';
import { SituacaoPedido } from 'src/app/shared/enums/situacao-pedido.enum';
import { PedidoConverter } from 'src/app/shared/helpers/converters/pedido-converter';
import { PurchaseConverter } from 'src/app/shared/helpers/converters/purchase-converter';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { SituacaoCompra } from 'src/app/shared/enums/situacao-compra.enum';
import { ProdutoCategoria } from 'src/app/models/produto-categoria';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { ContractAssignor } from 'src/app/models/contract-assignor';


@Component({
    selector: 'app-nova-compra-create',
    templateUrl: './nova-compra-create.component.html',
    styleUrls: ['./nova-compra-create.component.css']
})
export class NovacompraCreateComponent implements OnInit {

    constructor(
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private router: Router,
        private route: ActivatedRoute,
        private contratoService: ContratoService,
        private formBuilder: FormBuilder,
        private pedidoDataService: PedidoDataService,
        private modalService: NgbModal,
        private parametrosDataService: ParametrosDataService,
        private pedidoService: PedidoService,
        private gestorService: GestorService,
        private collaboratorService: ColaboradorService
        ) {
    }

    @ViewChild('modalAvisoColaboradores', { static: true })
    modalAvisoColaboradores: TemplateRef<any>;

    public purchaseOnline = true;
    public newPurchase = true;
    public copyPurchase = false;
    public continuePurchase = false;
    public checked = false;

    public arrayBooleanProdutos: Boolean[];

    private currentUser: Auth;

    //#region Paginação
    currentPage = 1;
    showItem = '10';
    //#endregion

    private currentPedidoValue: PedidoCadastro;
    private currentPurchaseValue: Purchase;
    public cedenteContrato: CedenteContrato[];
    public contractAssignor: ContractAssignor[];
    public cedenteContratoTradicional: CedenteContrato[];
    public cedenteContratoFlex: CedenteContrato[];
    public cedenteContratoIncentivo: CedenteContrato[];
    public cedenteContratoReembolso: CedenteContrato[];
    public purchaseForm: FormGroup;
    public purchase: Purchase;
    public gestorId: number;
    public cedenteId: number;
    public tipoBeneficio: any;

    public SituacaoPedido = SituacaoPedido;
    public SituacaoCompra = SituacaoCompra;
    public categoriaProduto = CategoriaProduto;
    public produtoCategoria: ProdutoCategoria[] = [];

    //#region Continuar Pedido properties
    public pedidoContinuarList: Pedido[] = [];
    //#endregion

    //#region Continuar Pedido properties
    public purchaseContinueList: Purchase[] = [];
    //#endregion

    //#region Copiar Pedido properties
    public pedidoCopiarList: Pedido[] = [];
    ////#endregion

    //#region Copiar Pedido properties
    public purchaseCopyList: Purchase[] = [];
    ////#endregion

    ngOnInit() {
        if(this.pedidoDataService.currentPurchaseInfoValue != null) {
            this.pedidoDataService.deleteCurrentPurchaseValue();
            this.pedidoDataService.deleteCurrentPurchaseInfoValue();
            this.pedidoDataService.deleteCurrentPurchasePaymentValue();
        }

        this.currentUser = this.authenticationService.currentUserValue;
        this.produtoCategoria = JSON.parse(localStorage.getItem('productCategory'));
        this.produtoCategoria = this.produtoCategoria.filter(el => el.canList && el.id != 7);
        this.produtoCategoria.sort((a, b) => (a.categoryListOrder > b.categoryListOrder) ? 1 : -1);

        if(this.getTotalCollaborators()){
            this.load();
            this.gestorId = 0;
            this.cedenteId = 0;
            this.gestorService.getAll(this.currentUser.token.assignorGuid).subscribe(
                response => {

                    this.gestorId = response.result[0].gestorId;
                    this.cedenteId = response.result[0].cedenteId;

                });

            this.purchase = new Purchase(0,'');
            this.purchase.purchaseItens = [];
            this.purchase.managerGuid = this.currentUser.token.userReferenceId;
            this.purchase.purchaseItens.forEach( e => {
                e.order.orderItens = [];
            });
        }

    }


    getTotalCollaborators(): boolean {
        this.collaboratorService.getTotalCollaborators(this.currentUser.token.assignorGuid).subscribe(
            response => {
                if(response.result <= 0){
                    this.modalService.open(this.modalAvisoColaboradores,{ centered: true, size: 'lg', backdrop: 'static' })
                    return false;
                }
            }
        )
        return true;
    }

    private load() {
        this.currentPurchaseValue = this.pedidoDataService.currentPurchaseValue;
        // sempre novo pedido quando entrar nessa página
        this.createForm(new Purchase(0,''));
        this.contratoService.getContracts(this.currentUser.token.assignorGuid,this.categoriaProduto.Tradicional).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.checked = true;
                    this.contractAssignor = response.result;
                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Erro ao carregar contrato do cedente' + error);
            }
        );
        this.arrayBooleanProdutos = [null, null, null, null]
    }

    changeCategory(e) {
        let category = e.target.value;
        this.contratoService.getContracts(this.currentUser.token.assignorGuid,category).subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.desselecionarProduto();
                    this.contractAssignor = response.result;
                } else {
                    this.alertService.error(response.message);
                }
            },
            error => {
                this.alertService.error('Erro ao carregar contrato do cedente' + error);
            }
        );
    }

    createForm(purchase: Purchase) {
        this.purchaseForm = this.formBuilder.group({
            purchaseDescription: new FormControl(purchase.purchaseDescription, [
                Validators.minLength(3),
                Validators.maxLength(100)
            ]),
            purchaseItens: new FormBuilder().array([
                new FormControl({
                    productId: new FormControl()
                }),
            ]),
            //pedidoItens: new FormControl(pedidoCadastro.pedidoItens, [])
        });
    }

    public get form() {
        return this.purchaseForm.controls;
    }

    selecionarProduto(){
        var inputCheckbox = <HTMLInputElement[]><any>document.getElementsByName('productId') ;

        let i = 0;
        inputCheckbox.forEach(input  =>{
            this.arrayBooleanProdutos[i] = input.checked;
            i++;
        });
    }

    desselecionarProduto(){
        var inputCheckbox = <HTMLInputElement[]><any>document.getElementsByName('productId') ;

        let i = 0;
        inputCheckbox.forEach(input =>{
            input.checked = false;

            this.arrayBooleanProdutos[i] = input.checked;
            i++;
        });
    }

    selecionarFlex(){
        var inputCheckbox = <HTMLInputElement[]><any>document.getElementsByName('productId') ;

        let i = 0;
         inputCheckbox.forEach(input =>{
            input.checked = false;

            if(input.id === '2'){
                input.checked = true;

            }
            this.arrayBooleanProdutos[i] = input.checked;
            i++;
        });
    }

    desselecionarFlex(){
        var inputCheckbox = <HTMLInputElement[]><any>document.getElementsByName('productId') ;

        let i = 0;
        inputCheckbox.forEach(input  =>{

            if(input.id === '2'){
                input.checked = false;

            }
            this.arrayBooleanProdutos[i] = input.checked;
            i++;
        });
    }


    onSubmit(purchase: Purchase) {
        this.pedidoDataService.deleteCurrentPedidoValue();
        this.pedidoDataService.deleteCurrentPedidoInfoValue();
        if (this.purchaseForm.valid) {
            let auxiliar = purchase.purchaseItens = [];
            auxiliar = this.arrayBooleanProdutos;
            let aux = 0;
            const prodGuid = [];
            const prodDesc = [];
            const prodCedId = [];
            const prodId = [];

            for (let i = 0; i < auxiliar.length; i++) {
                if (auxiliar[i]) {

                    this.purchase.purchaseItens[aux] = new PurchaseItens();
                    this.purchase.purchaseItens[aux].order = new Order();
                    this.purchase.purchaseItens[aux].order.orderItens = [];
                    prodGuid[aux] = this.contractAssignor[i].productEligibility.product.produtoGuid;
                    prodDesc[aux] = this.contractAssignor[i].productEligibility.product.descricaoProduto;
                    prodCedId[aux] = this.contractAssignor[i].id;
                    prodId[aux] = this.contractAssignor[i].productEligibility.product.produtoId;

                    this.purchase.purchaseDescription = (purchase.purchaseDescription === null ? '':purchase.purchaseDescription);
                    this.purchase.identifier = (purchase.purchaseDescription === null ? '':purchase.purchaseDescription);
                    this.purchase.assignorId = this.cedenteId;
                    this.purchase.purchaseItens[aux].productId = this.contractAssignor[i].productEligibility.product.produtoId;
                    this.purchase.purchaseItens[aux].order.assignorContractId = this.contractAssignor[i].id;
                    this.purchase.purchaseItens[aux].order.productGuid = this.contractAssignor[i].productEligibility.product.produtoGuid;
                    this.purchase.purchaseItens[aux].order.productDescription = this.contractAssignor[i].productEligibility.product.descricaoProduto;
                    this.purchase.purchaseItens[aux].order.productCategory = this.contractAssignor[i].productEligibility.product.categoriaProduto;
                    this.purchase.purchaseItens[aux].order.managerId = this.gestorId;
                    this.purchase.purchaseItens[aux].order.totalFeePercent = this.contractAssignor[i].feeValue == null ? 0 : this.contractAssignor[i].feeValue;
                    this.purchase.purchaseItens[aux].order.isPercent = this.contractAssignor[i].isPercentage == null ? false : this.contractAssignor[i].isPercentage;

                    this.purchase.purchaseItens[aux].ehEditavel = this.contractAssignor[i].isEditable;

                    aux++;
                }
            }

            /*
            if(!this.purchaseOnline && this.purchase.purchaseItens[0].order.productCategory === 2)
                this.purchase.flexIndividual = true;
            */

            this.pedidoDataService.setCurrentPurchaseValue(this.purchase);
            if (this.purchaseOnline) {
                const parametros = this.parametrosDataService.currentParametrosValue;
                if (parametros[ParametrosKey.temContaFlexivel] && this.purchase.purchaseItens[0].order.productCategory === 2 && !this.purchase.flexIndividual) {
                    this.router.navigate(['grupo'], { relativeTo: this.route.parent });
                } else {
                    this.router.navigate(['selecionarcolaborador'], { relativeTo: this.route.parent });

                }
            } else {
                const parametros = this.parametrosDataService.currentParametrosValue;
                if (parametros[ParametrosKey.temContaFlexivel] && this.purchase.purchaseItens[0].order.productCategory === 2 && !this.purchase.flexIndividual) {
                    this.router.navigate(['grupo'], { queryParams: { arq: true }, relativeTo: this.route.parent });
                } else {
                    this.router.navigate(['arquivo'], { relativeTo: this.route.parent });

                }
            }
        } else {
            GenericValidator.verifierValidatorsForm(this.purchaseForm);
        }

    }
    //#region Continuar Pedido methods
    carregarContinuarPurchase() {
        this.pedidoService.getPurcharses([this.SituacaoCompra.EmCriacao], this.currentUser.token.assignorGuid,0,'50').subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.purchaseContinueList = response.result.purchases;
                } else {
                    this.alertService.error(response.message);
                }
            }, error => { this.alertService.error(error.error); }
        );
    }
    continuar(purchase: Purchase) {
        if (purchase.purchaseState === SituacaoCompra.EmCriacao) {
            this.pedidoService.getPurchaseById(purchase.purchaseId, this.currentUser.token.assignorGuid, false).subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {
                        this.pedidoDataService.setCurrentPurchaseValue(PurchaseConverter.purchaseToPurchase(response.result));
                        this.router.navigate(['portal/novarecarga/selecionarcolaborador']);
                    } else {
                        this.alertService.error(response.message);
                    }
                }, error => { this.alertService.error(error.error); }
            );

        } else {
            this.alertService.error('Situação inválida para continuar o pedido');
        }
    }
    //#endregion

    //#region Copiar Pedido methods
    carregarCopiarPurchase() {
        this.pedidoService.getPurcharses([
            SituacaoCompra.Criado,
            SituacaoCompra.ParcialmenteProcessado,
            SituacaoCompra.ProcessadoComSucesso,
            SituacaoCompra.NaoProcessado,
            SituacaoCompra.Cancelado
        ], this.currentUser.token.assignorGuid,0,'50').subscribe(
            response => {
                if (response.status === ApiError.Sucesso) {
                    this.purchaseCopyList = response.result.purchases;
                } else {
                    this.alertService.error(response.message);
                }
            }, error => { this.alertService.error(error.error); }
        );
    }
    copiar(purchase: Purchase) {
        if (purchase.purchaseState !== SituacaoCompra.EmCriacao) {
            this.pedidoService.getPurchaseById(purchase.purchaseId, this.currentUser.token.assignorGuid, false).subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {
                        this.pedidoDataService.setCurrentPurchaseValue(PurchaseConverter.purchaseToNewPurchase(response.result));
                        if(response.result.isFlexPurchase){
                            this.router.navigate(['portal/novarecarga/selecionargrupocolaborador']);
                        } else {
                            this.router.navigate(['portal/novarecarga/selecionarcolaborador']);
                        }
                    } else {
                        this.alertService.error(response.message);
                    }
                }, error => { this.alertService.error(error.error); }
            );

        } else {
            this.alertService.error('Situação inválida para continuar o pedido');
        }
    }
    //#endregion

    navigateToHome() {
        this.router.navigate(['portal/home']);
    }

    navigateToCadastroColaborador() {
        this.router.navigate(['portal/colaborador/create']);
    }
}
